import React from "react";
import PropTypes from "prop-types";
import { AlertBanner, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import styles from "./DetectionBanner.module.css";

export default function DetectionBanner({ hasLaunchFinished, progress, onCloseBanner }) {
	return (
		(progress || hasLaunchFinished) && (
			<AlertBanner
				className={styles.isGeneratingContainer}
				description={translate(
					(progress && "commitment-tracking.detection-banner.message") ||
						"commitment-tracking.detection-banner.message.finished"
				)}
				iconElement={(progress && icon.faSpinner) || undefined}
				iconSpin={!!progress}
				title={
					(progress &&
						translate("commitment-tracking.detection-banner.title", {
							progress,
						})) ||
					translate("commitment-tracking.detection-banner.title.finished")
				}
				variant={(progress && "info") || "success"}
				onClose={hasLaunchFinished ? () => onCloseBanner(false) : undefined}
			/>
		)
	);
}

DetectionBanner.propTypes = {
	progress: PropTypes.string.isRequired,
};
